export default () => {
	const items = document.querySelectorAll('.js-collection-grid .products-grid__col:not(.products-grid__col--text)');
	const textBlocks = document.querySelectorAll('.js-collection-grid .products-grid__col--text');
	const plpGrid = document.querySelector('.plp-edit-grid');

	if (plpGrid) return;

	const textBlocksArray = Array.from(textBlocks);
	let blocks = textBlocksArray.map((item) => {
		return {
			item: item,
			targetIndex: item.dataset.targetIndex || -1,
			isShown: false,
			isWide: item.classList.contains('products-grid__col--wide')
		}
	});

	blocks = blocks.sort((a, b) => {
		return a.targetIndex - b.targetIndex;
	});

	// blocks.forEach((block) => {
	// 	block.item.style.backgroundColor = 'red';
	// });

	let cursor = 1;
	let blocksCursor;

	if (blocks.length) {
		blocksCursor = 0;
	} else {
		blocksCursor = -1;
	}

	items.forEach((item, index) => {
		let position = cursor % 24;
		let isBig = false;
		let isBigText = false;

		// if (item.classList.contains('collection-banner__wrapper')) {
		// 	console.log('Here!');
		// 	return;
		// }
		if (position === 3 || position === 13) {
			item.classList.add('products-grid__col--big');
			isBig = true;
			item.dataset.cursor = cursor;
			item.dataset.position = position;
			item.style.order = cursor;

			cursor+=4;
			return;
		}

		if (blocksCursor !== -1 && isBig == false) {
			let textBlockTargetIndex = +blocks[blocksCursor].targetIndex;
			// console.log({textBlockTargetIndex, index, cursor});
			if (position !== 3 && position !== 13) {
				if (cursor >= textBlockTargetIndex) {
					let block = blocks[blocksCursor];
					block.isShown = true;

					block.item.dataset.cursor = cursor;
					block.item.dataset.position = position;
					block.item.style.order = cursor;
					block.item.style.backgroundColor = 'transparent';

					if (block.isWide) {
						isBigText = true;
						cursor+=1;
					} {
						cursor+=1;
					}


					position = cursor % 24;
					setNextBlocksCursor();

					if (position === 3 || position === 13) {
						item.classList.add('products-grid__col--big');
						isBig = true;
						cursor+=3;
					}
				}
			}
		}

		item.dataset.cursor = cursor;
		item.dataset.position = position;
		item.style.order = cursor;
		cursor++;
	});


	setMobileGrid();


	function setMobileGrid(){
		let cursor = 0;
		let position = cursor % 9 ;
		let bigCursor = 0;

		const itemsBig = document.querySelectorAll('.js-collection-grid .products-grid__col--big');
		// --mobile-index
		// console.log(itemsBig);
		// console.log(blocks);

		//mobile grid
		items.forEach((item, index) => {
			if (!item.classList.contains('products-grid__col--big') || !item.classList.contains('collection-banner__wrapper')) {
				if (cursor == 0 || cursor % 9 == 0) {
					let bigItem = itemsBig[bigCursor];
					let textBlock = blocks[bigCursor];
					if (bigItem) {
						bigItem.style.setProperty('--mobile-index', cursor);
						cursor++
					}
					if (textBlock) {
						let textItem = textBlock.item;
						textItem.style.setProperty('--mobile-index', cursor);
						if (textBlock.isWide) {
							cursor += 2;
						} else {
							cursor++;
						}
					}
					bigCursor++;
				}

				item.style.setProperty('--mobile-index', cursor);
				cursor++;
			}
		})
	}


	function setNextBlocksCursor() {
		blocksCursor++
		if (blocksCursor >= blocks.length) {
			blocksCursor = -1;

			blocks.forEach((block) => {
				if (!block.isShown) {
					block.remove();
				}
			});
		}
	}
}
